import React from 'react';
import TeamMemberCard from './TeamMemberCard';
import './TeamGrid.css';

const TeamGrid = ({ members = [] }) => {
  // Fallback for empty members array
  if (members.length === 0) {
    const sampleMember = {
      name: "Sample Member",
      image: "/api/placeholder/400/400",
      education: "Computer Science, Example University",
      funFacts: [
        "This is a sample team member card",
        "Add real members to see their information",
        "You can add as many members as needed"
      ]
    };
    members = [sampleMember];
  }

  return (
    <div className="team-grid">
      <div className="team-grid-container">
        <ul className="team-grid-list">
          {members.map((member, index) => (
            <TeamMemberCard key={index} member={member} />
          ))}
        </ul>
      </div>
    </div>
  );
};

export default TeamGrid;